var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-progress',{staticClass:"zyc-charts-table-progress",attrs:{"show-text":false,"percentage":_vm.num > 100 ? 100 : _vm.num,"define-back-color":"rgba(0, 0, 0, 0)","color":'linear-gradient(360deg, #008CDC 0%, #02FEFF 100%);'}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-655bb437","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/zyc/other/progress.vue
// module id = null
// module chunks = 